export const homeUrl = "http://localhost:8080/";
export const homeUiUrl = "http://localhost:3000/";

export const librariesBaseUrl = "libraries/";
export const gamesBaseUrl = "games/"
export const gameInstancesBaseUrl = "gameinstances/"
